import React, { useMemo } from 'react';
import { BusChecklistType, ChecklistDataEntry, StudentChecklistValue } from './types';
import { useTranslation } from 'react-i18next';
import ChecklistValueCell from './ChecklistValueCell';
import { createColumnHelper } from '@tanstack/react-table';
import Table from './Table';

type BusChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	medicalCheck: StudentChecklistValue;
	RVM1D: StudentChecklistValue;
	VM2D: StudentChecklistValue;
	VM3D: StudentChecklistValue;
	closedArea: StudentChecklistValue;
	drivingTest: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};
const columnHelper = createColumnHelper<BusChecklistDataEntry>();

const BusChecklist = ({ checklist }: { checklist: BusChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('medicalCheck', {
				header: 'Medische Keuring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('RVM1D', {
				header: 'RVM1 D',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('VM2D', {
				header: 'VM2 D',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('VM3D', {
				header: 'VM3 D',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('closedArea', {
				header: 'Besloten Terrein',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('drivingTest', {
				header: 'Praktische Toets',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			medicalCheck: entry.values.find((value) => value.option.name === 'Medische Keuring') || {
				value: null,
			},
			RVM1D: entry.values.find((value) => value.option.name === 'RVM1 D') || { value: null },
			VM2D: entry.values.find((value) => value.option.name === 'VM2 D') || { value: null },
			VM3D: entry.values.find((value) => value.option.name === 'VM3 D') || { value: null },
			closedArea: entry.values.find((value) => value.option.name === 'Besloten Terrein') || {
				value: null,
			},
			drivingTest: entry.values.find((value) => value.option.name === 'Praktische Toets') || {
				value: null,
			},
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default BusChecklist;
